<template>

    <div>
        <el-upload drag :limit=limitNum :auto-upload="false" accept=".xlsx" action="" :before-upload="beforeUploadFile"
            :on-change="fileChange" :on-exceed="exceedFile" :file-list="fileList">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传xlsx文件</div>
        </el-upload>
        <br />
        <el-button size="small" type="primary" :loading="loading" @click="uploadFile">立即导入</el-button>
        <el-button type="primary" plain icon="el-icon-download">
            <el-link @click="download()">模板下载</el-link>
        </el-button>
        <el-button size="small" @click="cancelUpdate">取消</el-button>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    name: "FacultyInformation",
    data() {
        return {
            loading: false,
            limitNum: 1,
            fileList: [],
        }
    },
    methods: {
        download() {
            window.location.href = "https://wxoss.rompy.cn/template/xhd_self.xlsx"
        },
        handleClose(done) {
            this.fileList = []
            done();
        },
        // 文件超出个数限制时的钩子
        exceedFile(files, fileList) {
            this.$message.warning(`只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`);
        },
        // 文件状态改变时的钩子
        fileChange(file, fileList) {
            console.log('file:', file.raw)
            console.log('fileList:', this.fileList)
            this.fileList.pop();
            this.fileList.push(file.raw);
        },
        // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
        beforeUploadFile(file) {
            let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
            if (extension !== 'xlsx') {
                this.$message.warning('只能上传后缀是.xlsx的文件');
            }
        },
        //取消上传
        cancelUpdate() {
            this.dialogVisible = !this.dialogVisible
            this.fileList = []
        },
        uploadFile() {
            let that = this
            if (this.fileList.length === 0) {
                this.$message.warning('请上传文件');
            } else {
                //通过formData的文件传输，必须配置头部，否则将不能正常传输
                const config = {
                    headers: { "Content-Type": "multipart/form-data;boundary=" + new Date().getTime(), "token": sessionStorage.getItem("token") },
                    isNative: true,
                };
                let form = new FormData();
                var res;
                form.append('file', this.fileList[0]);
                // 请求自己服务器上传文件的接口
                this.loading = true;
                axios.post("/api/shop/uploadXhdSelfExcel", form, config).then(function (res) {
                    //console.log('response:', response);
                    //alert(response)
                    //导入成功，文件栏清空
                    //var res = response.toString().substr(0, 5)
                    that.loading = false;
                    if (res.data.code === 0) {
                        that.$message.success(res.data.message);
                        that.cancelUpdate();
                        //导入成功刷新页面
                        //window.location.reload()
                    } else {
                        that.$message.warning(res.data.message);
                    }
                })
            }
        },
        inputFile() {

        }
    },
}
</script>
